export default __webpack_public_path__ + "static/avatar-kayi-default-0-f622826175f2009d131a0596325d7bca.png";